/**
 * Portal Complete - Submission Confirmation Page
 *
 * Shown after vendor successfully submits their data.
 * Provides confirmation and next steps information.
 *
 * @epic DC-523 Vendor Certification Program
 * @task DC-532
 */

import React from 'react';
import { BRANDING } from '../../../config/branding';
import '../../../styles/vendor-portal.css';

export const PortalComplete: React.FC = () => {
  return (
    <div className="portal-page">
      <div className="portal-container">
        {/* Header */}
        <div className="portal-header">
          <div className="portal-logo">
            <span className="logo-icon">🧭</span>
            <span className="logo-text">{BRANDING.productName}</span>
          </div>
        </div>

        {/* Success Message */}
        <div className="portal-success">
          <div className="success-icon">✅</div>
          <h1>Submission Complete!</h1>
          <p>
            Thank you for submitting your data for FAIR certification assessment.
            Your submission has been received and is now queued for review.
          </p>
        </div>

        {/* What's Next */}
        <div className="next-steps">
          <h2>What Happens Next?</h2>
          <div className="steps-list">
            <div className="next-step">
              <span className="step-icon">1</span>
              <div className="step-content">
                <h3>Automated Analysis</h3>
                <p>
                  Your data will be automatically analyzed across four stations:
                  Data Quality, ML Readiness, Ontology Alignment, and FAIR Compliance.
                </p>
              </div>
            </div>
            <div className="next-step">
              <span className="step-icon">2</span>
              <div className="step-content">
                <h3>Expert Review</h3>
                <p>
                  An auditor will review the automated results and may reach out
                  if additional information is needed.
                </p>
              </div>
            </div>
            <div className="next-step">
              <span className="step-icon">3</span>
              <div className="step-content">
                <h3>Certification Decision</h3>
                <p>
                  Based on the assessment results, a certification tier will be
                  determined: Platinum, Gold, Silver, or Bronze.
                </p>
              </div>
            </div>
            <div className="next-step">
              <span className="step-icon">4</span>
              <div className="step-content">
                <h3>Certificate Issuance</h3>
                <p>
                  Upon approval, you'll receive an official FAIR certification
                  certificate with validity period and GxP compliance status.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="timeline-info">
          <h2>Expected Timeline</h2>
          <div className="timeline-card">
            <div className="timeline-item">
              <span className="timeline-label">Automated Analysis</span>
              <span className="timeline-value">Within 24 hours</span>
            </div>
            <div className="timeline-item">
              <span className="timeline-label">Expert Review</span>
              <span className="timeline-value">3-5 business days</span>
            </div>
            <div className="timeline-item">
              <span className="timeline-label">Final Decision</span>
              <span className="timeline-value">Within 2 weeks</span>
            </div>
          </div>
        </div>

        {/* Contact Info */}
        <div className="contact-info">
          <h2>Questions?</h2>
          <p>
            If you have any questions about your submission or the certification
            process, please contact the organization that invited you.
          </p>
        </div>

        {/* Footer */}
        <div className="portal-complete-footer">
          <p>You can safely close this page.</p>
        </div>
      </div>
    </div>
  );
};

export default PortalComplete;
